import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Typography } from "@bookips/sds";
import { AnimatePresence, motion } from "framer-motion";
import { useMemo } from "react";
import { purchasableSubjectsList } from "../../api/product";
/**
 * GNB 검색 추천 드롭다운 컴포넌트
 * input 아래에 표시되는 드롭다운 형태
 * framer-motion 애니메이션 적용
 */ export const SearchRecommendDropdown = (param)=>{
    let { isOpen , currentSubject , handleCurrentSubject , onClick , recommendSearchTermList , width =400  } = param;
    const hasRecommendSearchTerm = useMemo(()=>recommendSearchTermList.terms && recommendSearchTermList.terms.length > 0, [
        recommendSearchTermList
    ]);
    const subjects = purchasableSubjectsList();
    const handleTabChange = (subject)=>{
        handleCurrentSubject(subject);
        mixpanelEvent("Tab UI Clicked", {
            "Tab Type": "Search Dropdown",
            "Tab Name": subject
        });
    };
    const handleKeywordClick = (keyword, idx)=>{
        mixpanelEvent("Search Keyword Clicked", {
            "Button Name": keyword,
            Subject: currentSubject,
            "Keyword Order": idx + 1,
            "Placeholder Text": recommendSearchTermList === null || recommendSearchTermList === void 0 ? void 0 : recommendSearchTermList.placeHolder
        });
        onClick(keyword);
    };
    return /*#__PURE__*/ _jsx(AnimatePresence, {
        children: isOpen && /*#__PURE__*/ _jsxs(motion.div, {
            variants: {
                initial: {
                    opacity: 0,
                    filter: "blur(4px)"
                },
                animate: {
                    opacity: 1,
                    filter: "blur(0px)",
                    transition: {
                        delay: 0.25,
                        duration: 0.2,
                        ease: "easeInOut"
                    }
                },
                exit: {
                    opacity: 0,
                    filter: "blur(2px)",
                    transition: {
                        delay: 0,
                        duration: 0.2,
                        ease: "easeInOut"
                    }
                }
            },
            initial: "initial",
            animate: "animate",
            exit: "exit",
            className: cn("absolute z-[9999] rounded-xl bg-white shadow-sm", "top-full left-0 mt-1.5", "max-h-[400px] rounded-lg", "flex flex-col overflow-hidden", "border border-gray-100"),
            style: {
                width
            },
            role: "listbox",
            "aria-label": "검색 추천",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "shrink-0",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "relative flex items-center justify-center overflow-x-auto pt-1",
                        children: [
                            subjects.map((tab)=>{
                                const isSelected = currentSubject === tab.key;
                                return /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    onClick: ()=>handleTabChange(tab.key),
                                    className: cn("flex h-10 flex-1 items-center justify-center px-4 transition-colors", isSelected ? "font-semibold text-gray-900" : "text-gray-500 hover:text-gray-700"),
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        variant: "subtitle1",
                                        className: "shrink-0",
                                        children: tab.label
                                    })
                                }, tab.key);
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "absolute bottom-0 left-0 right-0 h-px bg-gray-100"
                            }),
                            /*#__PURE__*/ _jsx(motion.div, {
                                className: "absolute bottom-0 h-0.5 bg-gray-900",
                                animate: {
                                    left: "".concat(subjects.findIndex((tab)=>tab.key === currentSubject) / subjects.length * 100, "%")
                                },
                                transition: {
                                    type: "spring",
                                    stiffness: 500,
                                    damping: 30
                                },
                                style: {
                                    width: "".concat(100 / subjects.length, "%")
                                }
                            })
                        ]
                    })
                }),
                hasRecommendSearchTerm && /*#__PURE__*/ _jsxs("section", {
                    className: "flex flex-1 flex-col gap-3 overflow-y-auto px-5 py-6",
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "subtitle1",
                            className: "text-gray",
                            children: "쏠북 인기 검색어"
                        }),
                        /*#__PURE__*/ _jsx("ul", {
                            className: "flex flex-wrap gap-2",
                            children: recommendSearchTermList.terms.map((item, idx)=>/*#__PURE__*/ _jsx("li", {
                                    children: /*#__PURE__*/ _jsxs("button", {
                                        type: "button",
                                        onClick: ()=>handleKeywordClick(item, idx),
                                        className: cn("inline-flex items-center gap-1 rounded-md px-3 py-2", "border border-gray-200", "hover:bg-gray-100", "transition-colors"),
                                        children: [
                                            /*#__PURE__*/ _jsx(Typography, {
                                                variant: "subtitle2",
                                                className: "text-secondary-main",
                                                children: "#"
                                            }),
                                            /*#__PURE__*/ _jsx(Typography, {
                                                variant: "subtitle2",
                                                className: "text-primary",
                                                children: item
                                            })
                                        ]
                                    })
                                }, idx))
                        })
                    ]
                }),
                !hasRecommendSearchTerm && /*#__PURE__*/ _jsx("div", {
                    className: "flex flex-1 items-center justify-center py-10",
                    children: /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        className: "text-gray-500",
                        children: "추천 검색어가 없습니다"
                    })
                })
            ]
        })
    });
};
